import { render, staticRenderFns } from "./AppPishkhanApiIcon.vue?vue&type=template&id=123dca65"
import script from "./AppPishkhanApiIcon.vue?vue&type=script&lang=js"
export * from "./AppPishkhanApiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports